import { SeaportIcon } from '@transferz/fe-component-library/src/components/icons';
import Location from '@transferz/fe-component-library/src/components/icons/LocationIcon';
import PlaneLanding from '@transferz/fe-component-library/src/components/icons/PlaneLandingIcon';
import PlaneTakeOff from '@transferz/fe-component-library/src/components/icons/PlaneTakeOffIcon';
import { TrainIcon } from '@transferz/fe-component-library/src/components/icons/TrainIcon';
import { HubType } from '@transferz/fe-models';
import React from 'react';

export const LocationIcon: React.FC<any> = ( { location, inbound }: any) => {

  if (location?.hub) {
    if (location?.hubData?.hubType === HubType.Airport) {
      return inbound
        ? <PlaneTakeOff className="trip-icon trip-icon-plane" width="23" height="28" />
        : <PlaneLanding className="trip-icon trip-icon-plane" width="23" height="28" />;
    } else if (location?.hubData?.hubType === HubType.TrainStation) {
      return <TrainIcon className="trip-icon trip-icon-train" width="23" height="28" />;
    } else if (location?.hubData?.hubType === HubType.Seaport) {
      return <SeaportIcon className="trip-icon trip-icon-port" width="23" height="28" />;
    } else {
      return <Location className="trip-icon icon-location" />;
    }
  } else {
    return <Location className="trip-icon icon-location" />;
  }
};
